<template>
  <button
    class="relative py-2 text-lg text-cockpit-muted transition-all duration-300 hover:text-cockpit-green"
    :class="[{ 'cursor-not-allowed opacity-75': props.disabled }, {'font-semibold text-cockpit-green': props.selected}]"
  >
    {{ props.title }}
    <span
      class="absolute bottom-0 left-0 h-0.5 w-full origin-left scale-x-0 transform bg-cockpit-green transition-transform duration-300 ease-out"
      :class="{ 'scale-x-100': props.selected }"
    ></span>
  </button>
</template>

<script setup>
  const props = defineProps({
    title: String,
    selected: Boolean,
    disabled: Boolean,
  })
</script>
